import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";

var SvgPencilCrossed = function SvgPencilCrossed(props) {
  return _jsx("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    role: "img"
  }, props), {}, {
    children: _jsx("path", {
      fill: props.color || '#909090',
      d: "M2.854 2.146a.5.5 0 1 0-.708.708l4.069 4.068-2.022 2 2.804 2.773 2.007-1.984 4.142 4.143a.5.5 0 0 0 .708-.708L9.716 9.008l3.703-3.66a1.946 1.946 0 0 0 0-2.774 2 2 0 0 0-2.805 0L6.926 6.219 2.854 2.146ZM6.034 12.786l-2.807-2.773-1.173 3.332c-.176.499.093.778.609.602l3.37-1.161Z"
    })
  }));
};

export default SvgPencilCrossed;